import { emailValidation, nameValidation, phoneNumberValidation } from './base'
import { validator } from './core'

export const createAccountSchema = (countryCode: string) => {
  return validator.object().shape({
    email: emailValidation(),
    firstName: nameValidation('First name'),
    lastName: nameValidation('Last name'),
    phoneNumber: phoneNumberValidation('Phone', countryCode),
  })
}
